import { useTranslation } from 'react-i18next';

import { Badge, Label, TextInput } from '@/components/ui/daisy';

const SUGGESTIONS = [30, 45, 60, 75, 90, 120];

type ExamSettingsDefaultTimeFormProps = {
  value: number;
  onChange: (value: number) => void;
  error?: string;
};

export default function ExamDefaultTimeField({
  value,
  onChange,
  error,
}: ExamSettingsDefaultTimeFormProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.examWorkspace.settings',
  });

  return (
    <TextInput.Fieldset label={t('defaultTimeLabel')} labelAlt={error}>
      <TextInput
        type="number"
        placeholder={t('defaultTimePlaceholder')}
        color={!error ? 'default' : 'error'}
        className="w-full"
        value={value || ''}
        onChange={e => onChange(Number(e.target.value))}
      />

      <div className="flex items-center gap-2 flex-wrap">
        <Label className="text-xs">{t('suggestions')}</Label>
        {SUGGESTIONS.map(suggestion => (
          <Badge
            key={suggestion}
            color={suggestion === value ? 'primary' : 'default'}
            className="cursor-pointer"
            size="sm"
            onClick={() => onChange(suggestion)}
          >
            {t('minutes', { count: suggestion })}
          </Badge>
        ))}
      </div>
    </TextInput.Fieldset>
  );
}
